import React from 'react';
import HiddenGridRow from './HiddenGridRow';
import s from './Grid.scss';
var GridRow = function (_a) {
    var start = _a.start, end = _a.end, elementWidth = _a.elementWidth, elementHeight = _a.elementHeight, elementSpacing = _a.elementSpacing, renderElement = _a.renderElement, getElementId = _a.getElementId, getDuperbrowseItemId = _a.getDuperbrowseItemId, rowNumber = _a.rowNumber, bounds = _a.bounds;
    var onscreen = true;
    var visible = true;
    var rendered = true;
    if (bounds) {
        var rowHeight = elementHeight + elementSpacing;
        var top_1 = rowHeight * rowNumber + (bounds.offsetTop || 0);
        var bottom = top_1 + rowHeight;
        onscreen = bottom >= bounds.onscreenTop && top_1 <= bounds.onscreenBottom;
        visible = bottom >= bounds.visibleTop && top_1 <= bounds.visibleBottom;
        rendered = bottom >= bounds.renderedTop && top_1 <= bounds.renderedBottom;
    }
    if (!rendered) {
        return (React.createElement(HiddenGridRow, { key: getElementId(start), start: start, end: end, getDuperbrowseItemId: getDuperbrowseItemId, className: s['row'], marginTop: elementSpacing, height: elementHeight }));
    }
    var elements = [];
    for (var i = start; i < end; i++) {
        var style = {
            width: elementWidth,
            height: elementHeight,
        };
        if (i > start) {
            style.marginLeft = elementSpacing;
        }
        elements.push(renderElement({
            width: elementWidth,
            height: elementHeight,
            index: i,
            style: style,
            onscreen: onscreen,
            visible: visible,
        }));
    }
    return (React.createElement("div", { key: getElementId(start), className: s['row'], style: { marginTop: elementSpacing } }, elements));
};
GridRow.displayName = 'GridRow';
export default GridRow;
//# sourceMappingURL=GridRow.js.map